import type { ClientAppLogErrorParams, ClientAppLogPayload } from '@/app/components/search/logging/types.ts';
import { API_CALL_PREFIX } from '@/app/components/search/utils/api/apiUtils.ts';
import { API_NAME } from '@/app/components/search/common/apiTypes.ts';
import { splitStack } from '@/utils/errors.ts';

const describeError = (error: Error) => {
  const { heading, frames } = splitStack(error);
  return [heading, frames].filter(Boolean).join('\n');
};

const createErrorLogMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return describeError(error);
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
};

export const createCodeSourceName = (codeSourceName: string): string => `ClientSide:[${codeSourceName}]`;

export const createErrorPayload = ({ level, codeSourceName, error }: ClientAppLogErrorParams): ClientAppLogPayload => ({
  level,
  codeSourceName: createCodeSourceName(codeSourceName),
  logMessage: createErrorLogMessage(error),
  url: window.location.href,
});

export const sendAppLog = (payload: ClientAppLogPayload) => {
  if (navigator && navigator.sendBeacon) {
    const body = JSON.stringify(payload);
    const url = `${API_CALL_PREFIX}${API_NAME.APP_LOGGER}`;
    navigator.sendBeacon(url, body);
  } else {
    // TODO: decouple from clientAPICall
    // clientAPICall<ClientAppLogPayload, void>({
    //   apiName: API_NAME.APP_LOGGER,
    //   payload,
    // });
  }
};

export const clientAppLog = (params: ClientAppLogPayload) => {
  sendAppLog(params);
};

export const clientAppLogError = (params: ClientAppLogErrorParams) => {
  const payload = createErrorPayload(params);
  sendAppLog(payload);
};
